import React from 'react'

import { InvoiceActivity } from '../../types'
import './activityBadge.scss'

type Props = {
  activity?: InvoiceActivity
  sentManually?: boolean
  notSent?: boolean
  size?: 'sm' | 'md'
}

const sizeClass = (size: 'sm' | 'md') =>
  `invoice-activity-badge invoice-activity-badge--${size}`

const ActivityBadge: React.FC<Props> = ({
  activity,
  sentManually,
  notSent = false,
  size = 'sm',
}) => {
  if (notSent) {
    return (
      <span
        className={`${sizeClass(size)} badge rounded-pill bg-secondary-subtle text-secondary-emphasis`}
      >
        Not sent
      </span>
    )
  }

  if (!activity) {
    return null
  }

  let variantClass: string
  switch (activity) {
    case InvoiceActivity.CREATED:
      return <span className={`${sizeClass(size)} text-center`}>-</span>
    case InvoiceActivity.EMAIL_ON_QUEUE:
      variantClass = 'badge rounded-pill invoice-activity-badge--sending'
      break
    case InvoiceActivity.EMAIL_SENT:
      variantClass = 'badge rounded-pill bg-info'
      break
    case InvoiceActivity.EMAIL_VIEWED:
      variantClass = 'badge rounded-pill bg-success'
      break
    case InvoiceActivity.EMAIL_FAILED:
      variantClass = 'badge rounded-pill bg-danger'
      break
    default:
      variantClass = 'badge rounded-pill bg-info'
  }

  let label: string = activity
  if (activity === InvoiceActivity.EMAIL_SENT && sentManually) {
    label = 'Sent manually'
  }

  return (
    <span className={`${sizeClass(size)} ${variantClass}`}>
      {label}
    </span>
  )
}

export default ActivityBadge
